<template>
  <RF-Dialog
    :cpntStatus="statusGeral"
    :cpntLargura='"510px"'
    :cpntOnFecharDialog='finConfigContasFechar'>
    <template slot='titulo'>
      <!-- SETA O ICONE DO CAMPO -->
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>

      <!-- SETA O TITULO DA ABA -->
      <template v-if="cpntId === 0 || cpntId.length === 1 && cpntId[0] === 0">
        Nova Conta Bancária
      </template>
      <template v-else-if="cpntId >= 1 || cpntId.length === 1 && cpntId[0] >= 1">
        Edição da Conta Bancária - {{ cpntId >= 1 ? cpntId : cpntId[0] }}
      </template>
    </template>

    <template slot="conteudo">
      <div class="fin-cfg-con-ban-form">
        <div>
          <App-Select :data-time="time" class="app-cpnt-field fin-cfg-con-ban-form--id_banco" :class="campos.id_banco.class"
          :cpntStatus='campos.id_banco.status'
          :cpntId='campos.id_banco.id'
          :cpntTabIndex='campos.id_banco.tabIndex'
          :cpntNome='campos.id_banco.nome'
          :cpntValue='campos.id_banco.value'
          :cpntMensagem='campos.id_banco.mensagem'
          :cpntMensagemTipo='campos.id_banco.mensagemTipo'
          :cpntDisabled='campos.id_banco.disabled'
          :cpntMostrar='campos.id_banco.mostrar'
          :cpntExplica='campos.id_banco.explica'
          :cpntPlaceholder='campos.id_banco.placeholder'
          :cpntValueRef='campos.id_banco.valueRef'
          :cpntRouter='campos.id_banco.router'
          :cpntMethod='campos.id_banco.method'
          :cpntField='campos.id_banco.field'
          :cpntWhere='campos.id_banco.where'
          :cpntAddButForm='campos.id_banco.addButForm'
          :cpntKeyMostra='campos.id_banco.keyMostra'
          :cpntTipoOrder='campos.id_banco.tipoOrder'
          :cpntOrder='campos.id_banco.order'
          :cpntOptions='campos.id_banco.options'
          :cpntKeyValue='campos.id_banco.keyValue'
          :cpntSearchMinimo='campos.id_banco.searchMinimo'
          :cpntMask='campos.id_banco.mask'
          :cpntOptionInicialNome='campos.id_banco.optionInicialNome'
          :cpntOptionInicialValue='campos.id_banco.optionInicialValue'
          :cpntNewOption='campos.id_banco.newOption'
          
          :cpntOnBuscarOptions='campos.id_banco.onBuscarOptions'
          :cpntOnChange='campos.id_banco.onChange'
          :cpntOnBlur='campos.id_banco.onBlur'
          :cpntOnRealizaBusca='campos.id_banco.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.id_banco.onKeyPressEnter'
          ref="id_banco"
          ></App-Select>

          <App-Select :data-time="time" class="app-cpnt-field fin-cfg-con-ban-form--tp_conta" :class="campos.tp_conta.class"
          :cpntStatus='campos.tp_conta.status'
          :cpntId='campos.tp_conta.id'
          :cpntTabIndex='campos.tp_conta.tabIndex'
          :cpntNome='campos.tp_conta.nome'
          :cpntValue='campos.tp_conta.value'
          :cpntMensagem='campos.tp_conta.mensagem'
          :cpntMensagemTipo='campos.tp_conta.mensagemTipo'
          :cpntDisabled='campos.tp_conta.disabled'
          :cpntMostrar='campos.tp_conta.mostrar'
          :cpntExplica='campos.tp_conta.explica'
          :cpntPlaceholder='campos.tp_conta.placeholder'
          :cpntValueRef='campos.tp_conta.valueRef'
          :cpntRouter='campos.tp_conta.router'
          :cpntMethod='campos.tp_conta.method'
          :cpntField='campos.tp_conta.field'
          :cpntWhere='campos.tp_conta.where'
          :cpntAddButForm='campos.tp_conta.addButForm'
          :cpntKeyMostra='campos.tp_conta.keyMostra'
          :cpntTipoOrder='campos.tp_conta.tipoOrder'
          :cpntOrder='campos.tp_conta.order'
          :cpntOptions='campos.tp_conta.options'
          :cpntKeyValue='campos.tp_conta.keyValue'
          :cpntSearchMinimo='campos.tp_conta.searchMinimo'
          :cpntMask='campos.tp_conta.mask'
          :cpntOptionInicialNome='campos.tp_conta.optionInicialNome'
          :cpntOptionInicialValue='campos.tp_conta.optionInicialValue'
          :cpntNewOption='campos.tp_conta.newOption'
          
          :cpntOnBuscarOptions='campos.tp_conta.onBuscarOptions'
          :cpntOnChange='campos.tp_conta.onChange'
          :cpntOnBlur='campos.tp_conta.onBlur'
          :cpntOnRealizaBusca='campos.tp_conta.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.tp_conta.onKeyPressEnter'
          ref="tp_conta"
          ></App-Select>
        </div>

        <div>
          <App-Input :data-time="time" class="app-cpnt-field fin-cfg-con-ban-form--agencia" :class="campos.agencia.class"
          :cpntStatus='campos.agencia.status'
          :cpntId='campos.agencia.id'
          :cpntClassDivField='campos.agencia.classDivField'
          :cpntNome='campos.agencia.nome'
          :cpntValue='campos.agencia.value'
          :cpntAutoComplete='campos.agencia.autocomplete'
          :cpntMask='campos.agencia.mask'
          :cpntOptionInicialNome='campos.agencia.optionInicialNome'
          :cpntOptionInicialValue='campos.agencia.optionInicialValue'
          :cpntDisabled='campos.agencia.disabled'
          :cpntMostrar='campos.agencia.mostrar'
          :cpntAutoFocus='campos.agencia.autofocus'
          :cpntMensagem='campos.agencia.mensagem'
          :cpntMensagemTipo='campos.agencia.mensagemTipo'
          :cpntPlaceholder='campos.agencia.placeholder'
          :cpntPosicionar='campos.agencia.posicionar'
          :cpntOnChange='campos.agencia.onChange'
          :cpntOnBlur='campos.agencia.onBlur'
          ref='agencia'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field fin-cfg-con-ban-form--agencia_dv" :class="campos.agencia_dv.class"
          :cpntStatus='campos.agencia_dv.status'
          :cpntId='campos.agencia_dv.id'
          :cpntClassDivField='campos.agencia_dv.classDivField'
          :cpntNome='campos.agencia_dv.nome'
          :cpntValue='campos.agencia_dv.value'
          :cpntAutoComplete='campos.agencia_dv.autocomplete'
          :cpntMask='campos.agencia_dv.mask'
          :cpntOptionInicialNome='campos.agencia_dv.optionInicialNome'
          :cpntOptionInicialValue='campos.agencia_dv.optionInicialValue'
          :cpntDisabled='campos.agencia_dv.disabled'
          :cpntMostrar='campos.agencia_dv.mostrar'
          :cpntAutoFocus='campos.agencia_dv.autofocus'
          :cpntMensagem='campos.agencia_dv.mensagem'
          :cpntMensagemTipo='campos.agencia_dv.mensagemTipo'
          :cpntPlaceholder='campos.agencia_dv.placeholder'
          :cpntPosicionar='campos.agencia_dv.posicionar'
          :cpntOnChange='campos.agencia_dv.onChange'
          :cpntOnBlur='campos.agencia_dv.onBlur'
          ref='agencia_dv'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field fin-cfg-con-ban-form--conta" :class="campos.conta.class"
          :cpntStatus='campos.conta.status'
          :cpntId='campos.conta.id'
          :cpntClassDivField='campos.conta.classDivField'
          :cpntNome='campos.conta.nome'
          :cpntValue='campos.conta.value'
          :cpntAutoComplete='campos.conta.autocomplete'
          :cpntMask='campos.conta.mask'
          :cpntOptionInicialNome='campos.conta.optionInicialNome'
          :cpntOptionInicialValue='campos.conta.optionInicialValue'
          :cpntDisabled='campos.conta.disabled'
          :cpntMostrar='campos.conta.mostrar'
          :cpntAutoFocus='campos.conta.autofocus'
          :cpntMensagem='campos.conta.mensagem'
          :cpntMensagemTipo='campos.conta.mensagemTipo'
          :cpntPlaceholder='campos.conta.placeholder'
          :cpntPosicionar='campos.conta.posicionar'
          :cpntOnChange='campos.conta.onChange'
          :cpntOnBlur='campos.conta.onBlur'
          ref='conta'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field fin-cfg-con-ban-form--conta_dv" :class="campos.conta_dv.class"
          :cpntStatus='campos.conta_dv.status'
          :cpntId='campos.conta_dv.id'
          :cpntClassDivField='campos.conta_dv.classDivField'
          :cpntNome='campos.conta_dv.nome'
          :cpntValue='campos.conta_dv.value'
          :cpntAutoComplete='campos.conta_dv.autocomplete'
          :cpntMask='campos.conta_dv.mask'
          :cpntOptionInicialNome='campos.conta_dv.optionInicialNome'
          :cpntOptionInicialValue='campos.conta_dv.optionInicialValue'
          :cpntDisabled='campos.conta_dv.disabled'
          :cpntMostrar='campos.conta_dv.mostrar'
          :cpntAutoFocus='campos.conta_dv.autofocus'
          :cpntMensagem='campos.conta_dv.mensagem'
          :cpntMensagemTipo='campos.conta_dv.mensagemTipo'
          :cpntPlaceholder='campos.conta_dv.placeholder'
          :cpntPosicionar='campos.conta_dv.posicionar'
          :cpntOnChange='campos.conta_dv.onChange'
          :cpntOnBlur='campos.conta_dv.onBlur'
          ref='conta_dv'
          ></App-Input>
        </div>

        <div>
          <App-Input :data-time="time" class="app-cpnt-field fin-cfg-con-ban-form--titular" :class="campos.titular.class"
          :cpntStatus='campos.titular.status'
          :cpntId='campos.titular.id'
          :cpntClassDivField='campos.titular.classDivField'
          :cpntNome='campos.titular.nome'
          :cpntValue='campos.titular.value'
          :cpntAutoComplete='campos.titular.autocomplete'
          :cpntMask='campos.titular.mask'
          :cpntOptionInicialNome='campos.titular.optionInicialNome'
          :cpntOptionInicialValue='campos.titular.optionInicialValue'
          :cpntDisabled='campos.titular.disabled'
          :cpntMostrar='campos.titular.mostrar'
          :cpntAutoFocus='campos.titular.autofocus'
          :cpntMensagem='campos.titular.mensagem'
          :cpntMensagemTipo='campos.titular.mensagemTipo'
          :cpntPlaceholder='campos.titular.placeholder'
          :cpntPosicionar='campos.titular.posicionar'
          :cpntOnChange='campos.titular.onChange'
          :cpntOnBlur='campos.titular.onBlur'
          ref='titular'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field fin-cfg-con-ban-form--val_ini" :class="campos.val_ini.class"
          :cpntStatus='campos.val_ini.status'
          :cpntId='campos.val_ini.id'
          :cpntClassDivField='campos.val_ini.classDivField'
          :cpntNome='campos.val_ini.nome'
          :cpntValue='campos.val_ini.value'
          :cpntAutoComplete='campos.val_ini.autocomplete'
          :cpntMask='campos.val_ini.mask'
          :cpntOptionInicialNome='campos.val_ini.optionInicialNome'
          :cpntOptionInicialValue='campos.val_ini.optionInicialValue'
          :cpntDisabled='campos.val_ini.disabled'
          :cpntMostrar='campos.val_ini.mostrar'
          :cpntAutoFocus='campos.val_ini.autofocus'
          :cpntMensagem='campos.val_ini.mensagem'
          :cpntMensagemTipo='campos.val_ini.mensagemTipo'
          :cpntPlaceholder='campos.val_ini.placeholder'
          :cpntPosicionar='campos.val_ini.posicionar'
          :cpntOnChange='campos.val_ini.onChange'
          :cpntOnBlur='campos.val_ini.onBlur'
          ref='val_ini'
          ></App-Input>
        </div>

        <div :style="finConfigContasValorBancoCarteira() !== '' ? '' : 'visibility: hidden;'">
          <App-Toggles :data-time="time" class="app-cpnt-field fin-cfg-con-ban-form--bol_carteira" :class="campos.bol_carteira.class"
          :cpntStatus='campos.bol_carteira.status'
          :cpntId='campos.bol_carteira.id'
          :cpntClassDivField='campos.bol_carteira.classDivField'
          :cpntNome='campos.bol_carteira.nome'
          :cpntValue='campos.bol_carteira.value'
          :cpntMostrar='campos.bol_carteira.mostrar'
          :cpntMensagem='campos.bol_carteira.mensagem'
          :cpntMensagemTipo='campos.bol_carteira.mensagemTipo'
          :cpntOn='campos.bol_carteira.on'
          :cpntOff='campos.bol_carteira.off'
          :cpntExplica='campos.bol_carteira.explica'
          :cpntWidth='campos.bol_carteira.width'
          :cpntTabIndex='campos.bol_carteira.tabIndex'
          :cpntDisabled='campos.bol_carteira.disabled'
          :cpntOnChange='campos.bol_carteira.onChange'
          :cpntOnBlur='campos.bol_carteira.onBlur'
          ref='bol_carteira'
          ></App-Toggles>

          <App-Input :data-time="time" class="app-cpnt-field fin-cfg-con-ban-form--bol_cedente" :class="campos.bol_cedente.class" :style="campos.bol_carteira.value === true ? '' : 'visibility: hidden;'"
          :cpntStatus='campos.bol_cedente.status'
          :cpntId='campos.bol_cedente.id'
          :cpntClassDivField='campos.bol_cedente.classDivField'
          :cpntNome='campos.bol_cedente.nome'
          :cpntValue='campos.bol_cedente.value'
          :cpntAutoComplete='campos.bol_cedente.autocomplete'
          :cpntMask='campos.bol_cedente.mask'
          :cpntOptionInicialNome='campos.bol_cedente.optionInicialNome'
          :cpntOptionInicialValue='campos.bol_cedente.optionInicialValue'
          :cpntDisabled='campos.bol_cedente.disabled'
          :cpntMostrar='campos.bol_cedente.mostrar'
          :cpntAutoFocus='campos.bol_cedente.autofocus'
          :cpntMensagem='campos.bol_cedente.mensagem'
          :cpntMensagemTipo='campos.bol_cedente.mensagemTipo'
          :cpntPlaceholder='campos.bol_cedente.placeholder'
          :cpntPosicionar='campos.bol_cedente.posicionar'
          :cpntOnChange='campos.bol_cedente.onChange'
          :cpntOnBlur='campos.bol_cedente.onBlur'
          ref='bol_cedente'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field fin-cfg-con-ban-form--bol_seq_remessa" :class="campos.bol_seq_remessa.class" :style="campos.bol_carteira.value === true ? '' : 'visibility: hidden;'"
          :cpntStatus='campos.bol_seq_remessa.status'
          :cpntId='campos.bol_seq_remessa.id'
          :cpntClassDivField='campos.bol_seq_remessa.classDivField'
          :cpntNome='campos.bol_seq_remessa.nome'
          :cpntValue='campos.bol_seq_remessa.value'
          :cpntAutoComplete='campos.bol_seq_remessa.autocomplete'
          :cpntMask='campos.bol_seq_remessa.mask'
          :cpntOptionInicialNome='campos.bol_seq_remessa.optionInicialNome'
          :cpntOptionInicialValue='campos.bol_seq_remessa.optionInicialValue'
          :cpntDisabled='campos.bol_seq_remessa.disabled'
          :cpntMostrar='campos.bol_seq_remessa.mostrar'
          :cpntAutoFocus='campos.bol_seq_remessa.autofocus'
          :cpntMensagem='campos.bol_seq_remessa.mensagem'
          :cpntMensagemTipo='campos.bol_seq_remessa.mensagemTipo'
          :cpntPlaceholder='campos.bol_seq_remessa.placeholder'
          :cpntPosicionar='campos.bol_seq_remessa.posicionar'
          :cpntOnChange='campos.bol_seq_remessa.onChange'
          :cpntOnBlur='campos.bol_seq_remessa.onBlur'
          ref='bol_seq_remessa'
          ></App-Input>
        </div>
      </div>
    </template>

    <template slot='rodape'>
      <div class="fin-cfg-con-ban-form-botoes">
        <RF-Button
          :cpntStatus='botoes.cancelar.status' 
          :cpntId='botoes.cancelar.id' 
          :cpntTexto='botoes.cancelar.texto' 
          :cpntClass='botoes.cancelar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.cancelar.tabIndex'
          @onClickButton='botoes.cancelar.onClick'
        ></RF-Button>

        <RF-Button
          :cpntStatus='botoes.salvar.status' 
          :cpntId='botoes.salvar.id' 
          :cpntTexto='botoes.salvar.texto' 
          :cpntClass='botoes.salvar.class'
          :cpntMostrar='botoes.salvar.mostrar'
          :cpntTabIndex='botoes.salvar.tabIndex'
          @onClickButton='botoes.salvar.onClick'
        ></RF-Button>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.fin-cfg-con-ban-form {
  width: 100%;
  padding-top: 15px;
  text-align: left;
}
  .fin-cfg-con-ban-form > div:not(:first-child) {
    padding-top: 22px;
  }
  .fin-cfg-con-ban-form > div,
  .fin-cfg-con-ban-form > div > div {
    width: 100%;
  }

  .fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--id_banco {
    width: calc(70% - 10px);
    margin-right: 10px;
  }
  .fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--tp_conta {
    width: 30%;
  }


  .fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--agencia {
    width: calc(43% - 13px);
    margin-right: 3px;
  }
  .fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--agencia_dv {
    width: 7%;
    margin-right: 20px;
  }
  .fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--conta {
    width: calc(43% - 13px);
    margin-right: 3px;
  }
  .fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--conta_dv {
    width: 7%;
  }

  .fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--titular {
    width: calc(52% - 10px);
    margin-right: 10px;
  }
  .fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--val_ini {
    width: 48%;
  }

  .fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--bol_carteira,
  .fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--bol_cedente,
  .fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--bol_seq_remessa {
    width: calc((100% / 3) - (20px / 3));
  }
  .fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--bol_carteira,
  .fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--bol_cedente {
    margin-right: 10px;
  }

  .fin-cfg-con-ban-form-botoes {
    text-align: right;
  }
    .fin-cfg-con-ban-form-botoes > button:not(:first-child) {
      margin-left: 5px;
    }
</style>

<style>
.fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--agencia_dv > input {
  text-align: center;
}
.fin-cfg-con-ban-form > div > .fin-cfg-con-ban-form--conta_dv > input {
  text-align: center;
}
</style>

<script>
  export default {
    props: {
      cpntHashId: {
        required: false,
        default: function () {
          // INICIA A VARIAVEL ID
          var hash = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            hash = 'fin-cfg-con-ban-form-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(hash)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return hash
        }
      },
      cpntId: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        campos: {
          id_banco: {
            id: this.cpntHashId + '--id_banco',
            status: '',
            nome: 'Banco',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            apiEnv: 'id_banco',
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            newOption: false,
            onBuscarOptions: this.finConfigContasBuscarBancos,
            onChange: this.finConfigContasOnChangeValue
          },
          tp_conta: {
            id: this.cpntHashId + '--tp_conta',
            status: '',
            nome: 'Tipo de Conta',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [
              { id: '1', nome: 'Conta Corrente' },
              { id: '2', nome: 'Conta Poupança' }
            ],
            apiEnv: 'tp_conta',
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            newOption: false,
            onChange: this.finConfigContasOnChangeValue
          },
          agencia: {
            id: this.cpntHashId + '--agencia',
            status: '',
            nome: 'Agência',
            class: '',
            apiEnv: 'agencia',
            mostrar: true,
            value: '',
            onChange: this.finConfigContasOnChangeValue
          },
          agencia_dv: {
            id: this.cpntHashId + '--agencia_dv',
            status: '',
            nome: 'DV',
            class: '',
            apiEnv: 'agencia_dv',
            mostrar: true,
            value: '',
            onChange: this.finConfigContasOnChangeValue
          },
          conta: {
            id: this.cpntHashId + '--conta',
            status: '',
            nome: 'Conta',
            class: '',
            apiEnv: 'conta',
            mostrar: true,
            value: '',
            onChange: this.finConfigContasOnChangeValue
          },
          conta_dv: {
            id: this.cpntHashId + '--conta_dv',
            status: '',
            nome: 'DV',
            class: '',
            apiEnv: 'conta_dv',
            mostrar: true,
            value: '',
            onChange: this.finConfigContasOnChangeValue
          },
          titular: {
            id: this.cpntHashId + '--titular',
            status: '',
            nome: 'Títular',
            class: '',
            apiEnv: 'titular',
            mostrar: true,
            explica: { mensagem: 'Valor inicial da Conta no momento do cadastro' },
            value: '',
            onChange: this.finConfigContasOnChangeValue
          },
          val_ini: {
            id: this.cpntHashId + '--val_ini',
            status: '',
            nome: 'Valor inicial',
            class: '',
            apiEnv: 'val_ini',
            mostrar: true,
            value: '',
            mask: 'valorMoeda',
            explica: { mensagem: 'Valor inicial da Conta no momento do cadastro' },
            onChange: this.finConfigContasOnChangeValue
          },
          bol_carteira: {
            id: this.cpntHashId + '--bol_carteira',
            status: '',
            nome: 'Emitir boleto?',
            value: false,
            onChange: this.finConfigContasOnChangeValue
          },
          bol_cedente: {
            id: this.cpntHashId + '--bol_cedente',
            status: '',
            nome: 'Código Cedente',
            class: '',
            apiEnv: 'bol_cedente',
            mostrar: true,
            value: '',
            onChange: this.finConfigContasOnChangeValue
          },
          bol_seq_remessa: {
            id: this.cpntHashId + '--bol_seq_remessa',
            status: '',
            nome: 'Sequência Remessa',
            class: '',
            apiEnv: 'bol_seq_remessa',
            mostrar: true,
            value: '',
            onChange: this.finConfigContasOnChangeValue
          }
        },
        botoes: {
          cancelar: {
            status: '',
            id: this.cpntHashId + '-botoes--cancelar',
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: () => { this.finConfigContasFechar(false) }
          },
          salvar: {
            status: '',
            id: this.cpntHashId + '-botoes--salvar',
            texto: 'Salvar',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.finConfigContasSalvar() }
          },
        }
      }
    },
    mounted: function () {
      this.finConfigContasIniciar()
    },
    methods: {
      finConfigContasFechar: function (atualizar = false, id = null, dados = null) {
        if (atualizar === true && id !== null && dados === null) {
          this.finConfigContasBuscaDados(id, (retorno) => { this.finConfigContasFechar(atualizar, id, retorno) })
        } else {
          // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
          this.cpntFecharFormulario(atualizar, id, dados)

          // // VERIFICA SE DEVE MUDAR A ROTA DO VUE
          // if (this.$route.name === 'veiculo_form') {
          //   this.$router.push({ name: 'veiculo_gere', params: {} })
          // }
        }
      },
      finConfigContasIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.finConfigContasSetarStatusGeral('carregando')

        // VERIFICA SE ESTÁ EDITANDO ALGUM REGISTRO
        if (this.cpntId >= 1) {
          // SETA O STATUS DA PAGINA
          this.finConfigContasSetarStatusGeral('carregando')

          // BUSCA OS DADOS PARA O FORMULARIO
          this.finConfigContasBuscaDados(this.cpntId, (retorno) => {
            // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
            var chaves = Object.keys(this.campos)

            // RODA O VETOR DOS CAMPOS
            for (var indexC in chaves) {
              // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
              var chave = chaves[indexC]

              // SETA OS VALORES DO CAMPO
              this.finConfigContasSetarValorCampo(chave, retorno)

              // SETA O VALOR INICIAL DO CAMPO
              this.campos[chave].valueIni = this.campos[chave].value
            }

            // SETA O STATUS DA PAGINA
            this.finConfigContasSetarStatusGeral('')

            // VERIFICA O CAMPO QUE DEVE REALIZAR O FOCUS
            this.finConfigContasRealizarFocusCampo('id_con')
          })
        } else {
          // SETA O STATUS DA PAGINA
          this.finConfigContasSetarStatusGeral('')

          // VERIFICA O CAMPO QUE DEVE REALIZAR O FOCUS
          this.finConfigContasRealizarFocusCampo('id_con')

          // setTimeout(() => { this.finConfigContasFechar(true, 2) }, 2000)
        }
      },
      finConfigContasSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finConfigContasSetarValorCampo: function (chave, dados) {
        // INICIA A VARIAVEL DE VALOR
        var value = ''
        var options = null

        // VERIFICA O VALOR QUE DEVE SELECIONAR
        switch (chave) {
          case 'id_banco':
            // SETA O VALOR DO CAMPO
            value = { id: dados.id_banco, codigo: dados.id_banco_codigo, nome: dados.id_banco_nome, prioridade: dados.id_banco_prioridade }

            // INICIA A VARIAVEL PARA O CAMINHO DO ICONE DO BANCO
            if ([ '1' ].indexOf(value.id) === -1) {
              value._img = '/img/banco/' + value.id + '.png'
            }
            break

          case 'tp_conta':
            value = dados.tp_conta
            break

          case 'bol_carteira':
            value = [ '', null, undefined, '0' ].indexOf(dados.bol_carteira) === -1
            break

          case 'agencia':
          case 'agencia_dv':
          case 'conta':
          case 'conta_dv':
          case 'titular':
          case 'val_ini':
          case 'bol_cedente':
          case 'bol_seq_remessa':
            value = dados[chave]
            break
        }

        // PEGA OS OPTIONS DO CAMPO
        if (options === null && [ '', null, undefined ].indexOf(this.campos[chave].options) === -1 && this.campos[chave].options.length >= 1) {
          options = this.campos[chave].options
        }

        // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
        if (options !== null && options.length >= 1 && typeof value === 'string') {
          // PEGA O VALOR DO CAMPO
          var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

          // SETA O VALOR ENCONTRADO
          value = valor.length === 1 ? valor[0] : value
        }
        
        // VERIFICA SE TE DEVE ATUALIZAR O CMAPO
        if (chave === 'id_mod' && this.$store.state.flagBuscaVei === true) {
          // PEGA A MARCA DO VEICULO
          var id_mar = typeof this.campos.id_mar.value === "string" ? this.campos.id_mar.value : this.campos.id_mar.value.id

          // VERIFICA SE DEVE HABILITAR OU NÃO O CAMPO
          this.$set(this.campos[chave], 'disabled', id_mar === '')
        }

        // SETA O VALOR ATUALIZADO DO CAMPO
        this.$set(this.campos[chave], 'value', value)

        // VERIFICA SE TEM VALOR PARA ATUALIZAR
        if (options !== null) {
          this.$set(this.campos[chave], 'options', options)
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finConfigContasRealizarFocusCampo: function (campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.finConfigContasRealizarFocusCampo(campo, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[campo]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[campo]) === true ? this.$refs[campo][0] : this.$refs[campo]

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
              elemento.cpntRealizarFocus()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      finConfigContasValorBancoCarteira: function () {
        // INICIA A VARIAVEL
        var option = (this.campos.id_banco.value !== 'string') ? this.campos.id_banco.value : this.campos.id_banco.options.filter(item => item.id === this.campos.id_banco.value)[0]

        // RETORNA O VALOR DA CARTEIRA DO BANCO SELECIONADO
        return option.carteira
      },
      finConfigContasBuscaDados: function (id, callback) {
        // MONTA O QUERY GET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

        // SETA OS CAMPOS QUE DEVEJA 
        queryGet.field = {
          id: null,
          tp_conta: null,
          id_banco: { j: { id: null, codigo: null, nome: null, prioridade: null, carteira: null } },
          agencia: null,
          agencia_dv: null,
          conta: null,
          conta_dv: null,
          titular: null,
          val_ini: null,
          bol_carteira: null,
          bol_cedente: null,
          bol_seq_remessa: null
        }

        // SETA O WHERE QUE DEVE REALIZAR
        queryGet.where = { aAnd: [ { f: 'id', o: '=', v: id } ] }

        // FAZ A BUSCA DOS DADOS
        this.$store.state.comunicaAPI('/financeiro/config/conta/get/', 'GET', queryGet, (retorno) => {
          // PEGA O VALOR SOLICITADO
          retorno = retorno.data[0]

          // INICIA A VARIAVEL COM O NOME
          retorno.nome = ''

          // MONTA O NOME DO BANCO A SER MOSTRADO
          if ([ '1' ].indexOf(retorno.id) !== -1) {
            retorno.nome = retorno.id_banco
          } else {
            // INICIA A VARIAVEL PARA O CAMINHO DO ICONE DO BANCO
            retorno._img = '/img/banco/' + retorno.id_banco + '.png'

            // ADICIONA O NUMERO DA AGENCIA
            if ([ '', null, undefined ].indexOf(retorno.agencia) === -1) {
              // SETA O NUMERO DA AGENCIA
              retorno.nome = 'AG.' + retorno.agencia

              // SETA O DIGITO DA AGENCIA
              if ([ '', null, undefined ].indexOf(retorno.agencia_dv) === -1) {
                retorno.nome += '-' + retorno.agencia_dv
              }
            }
            
            // ADICIONA O NUMERO DA CONTA
            if ([ '', null, undefined ].indexOf(retorno.conta) === -1) {
              // SETA A INICIAL DA CONTA
              retorno.nome += ' C'

              // SETA O TIPO DA CONTA
              switch (retorno.tp_conta) {
                case '1':
                  retorno.nome += 'C'
                  break

                case '2':
                  retorno.nome += 'P'
                  break
              }

              // FINALIZA O NOME DA CONTA
              retorno.nome += '.' + retorno.conta

              // SETA O DIGITO DA CONTA
              if ([ '', null, undefined ].indexOf(retorno.conta_dv) === -1) {
                retorno.nome += '-' + retorno.conta_dv
              }
            }
          }

          // EXECUTA A FUNÇÃO CALLBACK
          callback(retorno)
        }, this.finConfigContasSetarStatusGeral)
      },
      finConfigContasOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'class', '')

        // // VERIFICA A AÇÃO DO CAMPO
        // switch (indexF[1]) {
        // }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finConfigContasBuscarBancos: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, order: { nome: 'asc' } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = { id: null, codigo: null, nome: null, prioridade: null, carteira: null }

          // SETA A ORDENAÇÃO QUE DEVE APRESENTAR
          queryGet.order = { prioridade: 'desc', nome: 'asc' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/banco/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.finConfigContasBuscarBancos(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.id_banco.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campos.id_banco.onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA O CAMINHO DA IMAGEM DO BANCO
          for (var indexR in registros) {
            registros[indexR]._img = '/img/banco/' + registros[indexR].id + '.png'
          }

          // SETA OS VALORES RECEBIDOS
          this.campos.id_banco.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      finConfigContasSalvar: function () {
        // SETA OS VALORES RECEBIDOS
        this.$set(this.botoes.salvar, 'status', 'carregando')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA A FUNÇÃO PARA FINALIZAÇÃO DO PROCESSO
        const finalizacao = () => {
          // SETA OS VALORES RECEBIDOS
          this.$set(this.botoes.salvar, 'status', '')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_MONTAR_FORMDATA_API(this.campos).then((formData) => {
          // INICIA A VARIAVEL
          var method = 'POST'

          // VERIFICA SE DEVE ADICIONAR O CODIGO DA CARTEIRA
          if (this.campos.bol_carteira.value === true) {
            formData.bol_carteira = this.finConfigContasValorBancoCarteira
          }

          // COMUNICA COM A API
          this.$store.state.comunicaAPI('/financeiro/config/conta', method, formData, (retorno) => {
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(retorno)
            
            // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
            this.finConfigContasFechar(true, ([ '', null, undefined ].indexOf(retorno.ref) === -1 && [ '', null, undefined ].indexOf(retorno.ref.id) === -1 ? retorno.ref.id : this.cpntId))
          }, this.finConfigContasSetarStatusGeral, (apiValid, apiStatus) => { this.finConfigContasTratarValidacao(apiValid, apiStatus, finalizacao) })
        })
      },
      finConfigContasTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          // SETA O STATUS DE CARREGANDO DO BOTÃO
          this.botoes.salvar.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      }
    }
  }
</script>
